<template>
    <div class="pages" v-loading="shareLoading" element-loading-text="分享中..."
        element-loading-background="rgba(255,255,255,0.6)">
        <div class="top">
            <div class="flex items-center gap-[30px]">
                <span class="title">匹配结果</span>
                <div class="actions" v-if="props.usertype == 4">
                    <el-checkbox v-model="selectAll" @change="toggleSelectAll">全选</el-checkbox>
                    <span class="count" v-if="selectedIdxs.length">已选 {{ selectedIdxs.length }}</span>
                </div>
            </div>
            <div>
                <el-button v-if="selectedIdxs.length" type="primary" :loading="shareLoading" :disabled="shareLoading"
                    @click="onShare">分享</el-button>
            </div>

        </div>
        <el-dialog v-model="shareVisible" title="分享图片" width="460px" align-center>
            <div style="display:flex;align-items:center;justify-content:center;padding:12px;">
                <img :src="shareImageUrl" style="max-width:100%;border-radius:8px;width: 360px;height: 360px;" />
            </div>
            <template #footer>
                <div style="display:flex;justify-content:flex-end;gap:10px;padding:0 8px;">
                    <el-button @click="shareVisible = false">关闭</el-button>
                    <el-button type="primary" @click="onDownloadShare">下载图片</el-button>
                </div>
            </template>
        </el-dialog>
        <el-checkbox-group v-model="selectedIdxs" class="result-list" @change="onSelectItem">
            <div v-for="(item, idx) in resultDataList" :key="item.id || idx" class="item-card" @click="goDetail(item)">
                <div class="select-checkbox" @click.stop>
                    <el-checkbox v-if="props.usertype == 4" :label="item.id" />
                </div>
                <div class="item-cover">
                    <el-carousel class="cover-swiper" :interval="3000" height="260px" autoplay
                        indicator-position="none">
                        <el-carousel-item v-for="(img, ii) in item.scene_file.split(',').filter(Boolean)" :key="ii">
                            <img :src="img" class="cover-img" />
                        </el-carousel-item>
                    </el-carousel>
                    <div class="match-badge">{{ item.ui.match_percent }}% 匹配</div>
                    <div class="cover-theme matched">{{ item.ui.category }}</div>
                </div>
                <div class="item-body">
                    <div class="templatetitle">{{ item.ui.title }}</div>
                    <div class="chips">
                        <el-tag v-for="(t, i) in item.ui.tags" :key="i" size="small" effect="plain" type="success"
                            class="chip">{{ t }}</el-tag>
                    </div>
                    <div class="field field-inline" v-if="item.ui.colors && item.ui.colors.length > 0">
                        <span class="field-label">主色调</span>
                        <div class="palette">
                            <div v-for="(c, i) in item.ui.colors" :key="i" class="palette-swatch"
                                :style="{ backgroundColor: c }"></div>
                        </div>
                    </div>
                    <div class="metrics">
                        <div class="metric">
                            <span class="metric-label">类型</span>
                            <el-progress :percentage="item.scores.matchDetails.sceneType" :stroke-width="8"
                                class="metric-progress" color="#666fff" />
                        </div>
                        <div class="metric">
                            <span class="metric-label">主题</span>
                            <el-progress :percentage="item.scores.matchDetails.theme" :stroke-width="8"
                                class="metric-progress" color="#f999ff" />
                        </div>
                        <div class="metric">
                            <span class="metric-label">风格</span>
                            <el-progress :percentage="item.scores.matchDetails.style" :stroke-width="8"
                                class="metric-progress" color="#ff9999" />
                        </div>
                        <div class="metric">
                            <span class="metric-label">颜色</span>
                            <el-progress :percentage="item.scores.matchDetails.color" :stroke-width="8"
                                class="metric-progress" />
                        </div>
                        <div class="metric">
                            <span class="metric-label">物料</span>
                            <el-progress :percentage="item.scores.matchDetails.materials" :stroke-width="8"
                                class="metric-progress" color="#ff9900" />
                        </div>
                    </div>


                </div>
            </div>
        </el-checkbox-group>
    </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, reactive, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { PictureFilled } from '@element-plus/icons-vue'
import { shareQrcode } from '@/api/match'
import { ElCheckboxGroup, ElCheckbox, ElCarousel, ElCarouselItem, ElTag, ElProgress, ElDialog } from 'element-plus'
//@ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'
const textarea2 = ref('')
const selectedIdxs = ref<number[]>([])
const onSelectItem = (vals: any[]) => {
    selectAll.value = resultDataList.value.length > 0 && vals.length === resultDataList.value.length
}
const goDetail = (item: any) => { }
const selectAll = ref(false)
const toggleSelectAll = (val: boolean) => {
    if (val) {
        selectedIdxs.value = resultDataList.value.map((t: any) => t.id)
    } else {
        selectedIdxs.value = []
    }
}
const props = defineProps({
    plan: {
        type: Object,
        default: () => ({})
    },
    usertype: {
        type: Number,
        default: 1
    }
})
const route = useRoute()
const shareLoading = ref(false)
const shareVisible = ref(false)
const shareImageUrl = ref('')
const resultDataList = computed(() => {
    console.log(props.plan.template_list)
    return props.plan.template_list || []
})

watch(() => props.plan && (props.plan as any).template_list, (val) => {
    // console.log('template_list updated', Array.isArray(val) ? val.length : val)

}, { immediate: true, deep: true })
const onDownloadShare = async () => {
    const url = shareImageUrl.value
    if (!url) return
    try {
        const resp = await fetch(url)
        const blob = await resp.blob()
        const a = document.createElement('a')
        const obj = URL.createObjectURL(blob)
        a.href = obj
        a.download = 'share.png'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(obj)
    } catch {
        window.open(url, '_blank')
    }
}

const onShare = async () => {
    let params = {
        match_order_id: props.plan.match_order_id,
        template_ids: selectedIdxs.value.join(',')
    }
    shareLoading.value = true
    try {
        const res = await shareQrcode(params)
        if (res?.data?.code === 200) {
            shareImageUrl.value = res?.data?.share_url || res?.data?.data?.share_url || ''
            if (shareImageUrl.value) shareVisible.value = true
        } else {
        }
    } finally {
        shareLoading.value = false
    }
    // share_url
    // const res = await shareQrcode({
    //     business_id: props.plan.id
    // })
    // if (res?.data?.code === 200) {
    //     ElMessage.success('分享成功')
    // } else {
    //     ElMessage.error(res?.data?.msg || '分享失败')
    // }
}
</script>
<style lang="scss" scoped>
.pages {
    width: 100%;
    height: 100%;


}

.top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    padding: 16px;
    height: 60px;
    width: 100%;
    border-bottom: 1px solid #eef1f5;

    .actions {
        display: flex;
        align-items: center;
        gap: 10px;
    }
}

.result-list {
    width: 100%;
    padding: 16px;
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    height: calc(100% - 60px);
    overflow: auto;
}

.item-card {
    display: inline-block;
    position: relative;
    background: #fff;
    border: 1px solid #eef1f5;
    border-radius: 12px;
    overflow: hidden;
    width: calc(20% - 16px);
    min-width: 300px;
    height: 500px;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    cursor: pointer;
}

.item-card:hover {
    box-shadow: 0 8px 24px rgba(31, 35, 40, 0.08);
    transform: translateY(-2px);
}

.select-checkbox {
    position: absolute;
    top: 12px;
    left: 12px;
    width: 30px;
    text-align: center;
    z-index: 2;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 6px;
}

.select-checkbox :deep(.el-checkbox__label) {
    display: none;
}

.item-cover {
    position: relative;
}

.cover-swiper {
    width: 100%;
}

:deep(.el-carousel__container) {
    border-bottom: 1px solid #f0f2f5;
}

.cover-img {
    width: 100%;
    height: 260px;
    object-fit: cover;
}

.match-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 12px;
    color: #fff;
    background: #2a66ff;
    border-radius: 16px;
    padding: 4px 8px;
    height: 24px;
    display: flex;
    align-items: center;
}

.cover-theme {
    position: absolute;
    bottom: 12px;
    left: 12px;
    font-size: 12px;
    color: #fff;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 12px;
    padding: 4px 8px;
    height: 24px;
    display: flex;
    align-items: center;
}

.item-body {
    padding: 12px;
}

.templatetitle {
    font-size: 16px;
    font-weight: 600;
    color: #1f2328;
    margin-bottom: 10px;
    height: 16px;
    display: flex;
    align-items: center;
}

.chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;
}

.chip {
    border-radius: 10px;
}

.metrics {
    margin-top: 4px;
}

.metric {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
}

.metric-label {
    width: 40px;
    font-size: 12px;
    color: #6b7280;
}

.metric-progress {
    flex: 1;
}

.metric-val {
    width: 40px;
    font-size: 12px;
    text-align: right;
    color: #111827;
}

.field-inline {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    margin-bottom: 12px;
}

.field-label {
    font-size: 12px;
    color: #6b7280;
}

.palette {
    display: flex;
    gap: 6px;
}

.palette-swatch {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
}
</style>
